import React from "react";
import { GlobeHemisphereEast, UsersThree, Lightbulb, HandHeart } from "@phosphor-icons/react";

// "Our Values" section. Data lives here (extracted from About.jsx) so the
// parent stays focused on layout composition.
const VALUES = [
  {
    id: "cultural",
    title: "Cultural",
    icon: GlobeHemisphereEast,
    body: "We draw strength from tradition while creating new paths by blending the wisdom of the past with fresh ideas to meet the needs of today and the dreams of tomorrow.",
  },
  {
    id: "co-production",
    title: "Co-production",
    icon: UsersThree,
    body: "We believe the best solutions come from working together. That's why we build with you, listen to your experiences, and shape care that truly reflects your community's voice.",
  },
  {
    id: "evidence-innovation",
    title: "Evidence & Innovation",
    icon: Lightbulb,
    body: "Knowledge grows when it's connected to real life. By combining research with lived experience, we create approaches that are thoughtful, adaptable, and meaningful where you are.",
  },
  {
    id: "dignity",
    title: "Dignity",
    icon: HandHeart,
    body: "Every person's story matters. We bring together South Asian data and personal journeys to design care that respects who you are, with compassion, choice, and humility at its heart.",
  },
];

export default function AboutValuesSection() {
  return (
    <section className="md-section md-about-values" data-testid="about-values-section">
      <div className="md-about-values-bg" aria-hidden />
      <div className="md-container">
        <div className="md-about-values-intro">
          <div className="md-label-eyebrow mb-3" style={{ color: "var(--md-secondary)" }}>What we stand for</div>
          <h2 className="text-3xl md:text-5xl font-serif" data-testid="about-values-title">
            Our <em style={{ color: "var(--md-secondary)", fontStyle: "italic" }}>Values</em>
          </h2>
          <p className="text-base mt-3 md-about-values-sub">
            The principles that shape every conversation, programme and partnership at MindDhara.
          </p>
        </div>
        <div className="md-about-values-grid">
          {VALUES.map((v) => {
            const Icon = v.icon;
            return (
              <article
                key={v.id}
                className="md-about-value-card"
                data-testid={`about-value-${v.id}`}
              >
                <div className="md-about-value-ico" aria-hidden>
                  <Icon size={36} weight="duotone" />
                </div>
                <h3 className="md-about-value-title font-serif" data-testid={`about-value-title-${v.id}`}>
                  {v.title}
                </h3>
                <p className="md-about-value-body">{v.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
